/* eslint-disable no-new */
/* eslint-disable */

import Vue from 'vue'
import App from './App'
import App2 from './App2'
import router from './router'
import store from './store'
import Topbar from './components/Topbar'
import LoginPage from './components/LoginPage'
import axios from 'axios'
import wait from 'vue-wait'
import toasted from 'vue-toasted'
import VueSelect from "vue-cool-select"
import ImageKit from "imagekitio-vue"

Vue.component('Topbar', Topbar)
Vue.component('LoginPage', LoginPage)

Vue.config.productionTip = true
Vue.config.keyCodes = {
  "arrowkeys": [38, 40]
};
Vue.use(wait)
Vue.use(toasted, {iconPack : 'fontawesome', className: ['toast-global']})
Vue.use(VueSelect, {
  theme: "bootstrap"
});

Vue.use(ImageKit, {
  publicKey: "public_HQy327V7JWhapq05HvfQpHGgtkA=",
  urlEndpoint: "https://ik.imagekit.io/5gbpaxbik42/",
  authenticationEndpoint: "https://utks.lenoi.net/api/bids/auth-for-upload"
})

// 401 burst'ünde yalnızca ilk isteğin yönlendirme yapması için tek-atış kilidi
let isHandling401 = false

new Vue({
  store,
  el: '#app',
  router,
  components: { App2, Topbar, LoginPage },
  template: '<App2/>',
  wait: new wait(),
  beforeCreate() {
    
    axios.defaults.headers = { 'Content-Type': 'application/json' }
    axios.defaults.baseURL = process.env.NODE_ENV == "production"
      ? "https://utks.lenoi.net" : "http://localhost:5000"

    // --- Global 401 handling: oturum ölünce tek seferde login'e yönlendir, sonra geri dön ---
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401 && !isHandling401) {
          isHandling401 = true
          store.dispatch('logout')                 // session + localStorage temizler
          const release = () => { isHandling401 = false }
          const current = router.currentRoute
          if (current.path === '/login') {
            release()
          } else {
            const query = current.path === '/logout' ? {} : { redirect: current.fullPath }
            router.push({ path: '/login', query }).then(release).catch(release)
          }
        }
        return Promise.reject(error)               // isteği yapan bileşen kendi hatasını da görsün
      }
    )

    this.$store.dispatch('readSessionFromLocalStorage')
    .then(res => {
      if(!res.isTokenRead) {
        if(this.$route.path === '/login')
          this.$router.push('/login')
        else
          this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
      }
      else {
        if(!res.isSessionRead && !this.$store.getters.isAuthenticated && this.$route.name != 'LoginPage') {
          this.$store.dispatch('readUserConfig')
            .then(resp => {
              if(resp.data.hasError)
                this.$router.push('/logout')
              else
                this.$router.push('/')
            })
            .catch(err => { this.$router.push('/logout') })
        } else {
          // 401 gelirse global interceptor logout + login yönlendirmesini yapıyor
          this.$store.dispatch('checkSession').catch(() => {})
        }
      }
    })
    .then(() => {
      this.$store.commit('changeFirstLoading', false)
      this.$store.commit('changeLoadingState', false) 
    })
  },
  mounted() {
    //this.$store.commit('changeLoadingState', false)
  }
})



// WEBPACK FOOTER //
// ./src/main.js